import { render, staticRenderFns } from "./TipMessages.vue?vue&type=template&id=eb657fa2&scoped=true"
import script from "./TipMessages.vue?vue&type=script&lang=ts"
export * from "./TipMessages.vue?vue&type=script&lang=ts"
import style0 from "./TipMessages.vue?vue&type=style&index=0&id=eb657fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb657fa2",
  null
  
)

export default component.exports